// extracted by mini-css-extract-plugin
module.exports = {"bullets":"styles_bullets__td8jf","letters":"styles_letters__4div-"};